import { getValueByPath } from './utils';
import { City } from "../groups/common/address/City";
import { Country } from "../groups/common/address/Country";
import { PostalCode } from "../groups/common/address/PostalCode";
import { Region } from "../groups/common/address/Region";
import { StreetAddress } from "../groups/common/address/StreetAddress";
import { StreetAddress2 } from "../groups/common/address/StreetAddress2";
import { AccountHolder } from "../groups/payload/bankaccounts/AccountHolder";
import { AccountNumber } from "../groups/payload/bankaccounts/AccountNumber";
import { AccountType } from "../groups/payload/bankaccounts/AccountType";
import { Bic } from "../groups/payload/bankaccounts/Bic";
import { Currency } from "../groups/payload/bankaccounts/Currency";
import { Iban } from "../groups/payload/bankaccounts/Iban";
import { IsDefault } from "../groups/payload/bankaccounts/IsDefault";
import { RoutingNumber } from "../groups/payload/bankaccounts/RoutingNumber";
import { BillingEmail } from "../groups/payload/billing/BillingEmail";
import { BusinessKrn } from "../groups/payload/businessinformation/BusinessKrn";
import { CompanyName } from "../groups/payload/businessinformation/CompanyName";
import { FcaNumber } from "../groups/payload/businessinformation/FcaNumber";
import { IsRegistered } from "../groups/payload/businessinformation/IsRegistered";
import { LegalForm } from "../groups/payload/businessinformation/LegalForm";
import { DateOfBirth } from "../groups/payload/businessinformation/persons/DateOfBirth";
import { FirstName } from "../groups/payload/businessinformation/persons/FirstName";
import { LastName } from "../groups/payload/businessinformation/persons/LastName";
import { PersonId } from "../groups/payload/businessinformation/persons/PersonId";
import { PersonIdentityDocument } from "../groups/payload/businessinformation/persons/PersonIdentityDocument";
import { PersonProofOfAddress } from "../groups/payload/businessinformation/persons/PersonProofOfAddress";
import { PersonRole } from "../groups/payload/businessinformation/persons/PersonRole";
import { PersonalIdentifier } from "../groups/payload/businessinformation/persons/PersonalIdentifier";
import { ProductChannel } from "../groups/payload/businessinformation/ProductChannel";
import { RegistrationAuthority } from "../groups/payload/businessinformation/RegistrationAuthority";
import { RegistrationCountry } from "../groups/payload/businessinformation/RegistrationCountry";
import { RegistrationId } from "../groups/payload/businessinformation/RegistrationId";
import { ShouldAutoCaptureOrders } from "../groups/payload/businessinformation/ShouldAutoCaptureOrders";
import { SubjectToVat } from "../groups/payload/businessinformation/SubjectToVat";
import { VatId } from "../groups/payload/businessinformation/VatId";
import { BusinessSize } from "../groups/payload/BusinessSize";
import { Delay } from "../groups/payload/collateral/settlementschedule/Delay";
import { Interval } from "../groups/payload/collateral/settlementschedule/Interval";
import { ContractEntity } from "../groups/payload/ContractEntity";
import { ContractFlowMarket } from "../groups/payload/ContractFlowMarket";
import { ContractOnboardingType } from "../groups/payload/ContractOnboardingType";
import { BusinessConcepts } from "../groups/payload/instores/BusinessConcepts";
import { ContactEmail } from "../groups/payload/instores/ContactEmail";
import { Name } from "../groups/payload/instores/Name";
import { SellingCountries } from "../groups/payload/instores/SellingCountries";
import { StoreCategory } from "../groups/payload/instores/StoreCategory";
import { StoreId } from "../groups/payload/instores/StoreId";
import { SupportEmail } from "../groups/payload/instores/SupportEmail";
import { SupportPhone } from "../groups/payload/instores/SupportPhone";
import { MerchantId } from "../groups/payload/MerchantId";
import { MerchantPortalAccountEmail } from "../groups/payload/MerchantPortalAccountEmail";
import { MerchantPortalAccountRole } from "../groups/payload/MerchantPortalAccountRole";
import { Channel } from "../groups/payload/onboardingmetadata/Channel";
import { DistributionPartner } from "../groups/payload/onboardingmetadata/DistributionPartner";
import { Platform } from "../groups/payload/onboardingmetadata/Platform";
import { Countries } from "../groups/payload/paymentproduct/Countries";
import { ProductType } from "../groups/payload/paymentproduct/ProductType";
import { PlatformAccount } from "../groups/payload/PlatformAccount";
import { SensitiveGoods } from "../groups/payload/SensitiveGoods";
import { SourceIdentifier } from "../groups/payload/SourceIdentifier";
import { TemplateId } from "../groups/payload/TemplateId";
import { UnderwritingInquiryEmail } from "../groups/payload/UnderwritingInquiryEmail";
const ALL_FIELDS = {
    bank_accounts: {
        account_holder: AccountHolder,
        account_number: AccountNumber,
        account_type: AccountType,
        bic: Bic,
        currency: Currency,
        iban: Iban,
        is_default: IsDefault,
        routing_number: RoutingNumber
    },
    billing: {
        billing_email: BillingEmail
    },
    business_information: {
        business_krn: BusinessKrn,
        company_name: CompanyName,
        fca_number: FcaNumber,
        is_registered: IsRegistered,
        legal_form: LegalForm,
        operational_address: {
            city: City,
            country: Country,
            postal_code: PostalCode,
            region: Region,
            street_address: StreetAddress,
            street_address2: StreetAddress2
        },
        persons: {
            date_of_birth: DateOfBirth,
            first_name: FirstName,
            home_address: {
                city: City,
                country: Country,
                postal_code: PostalCode,
                region: Region,
                street_address: StreetAddress,
                street_address2: StreetAddress2
            },
            last_name: LastName,
            person_id: PersonId,
            person_identity_document: PersonIdentityDocument,
            person_proof_of_address: PersonProofOfAddress,
            person_role: PersonRole,
            personal_identifier: PersonalIdentifier
        },
        product_channel: ProductChannel,
        registered_address: {
            city: City,
            country: Country,
            postal_code: PostalCode,
            region: Region,
            street_address: StreetAddress,
            street_address2: StreetAddress2
        },
        registration_authority: RegistrationAuthority,
        registration_country: RegistrationCountry,
        registration_id: RegistrationId,
        should_auto_capture_orders: ShouldAutoCaptureOrders,
        subject_to_vat: SubjectToVat,
        vat_id: VatId
    },
    business_size: BusinessSize,
    collateral: {
        settlement_schedule: {
            delay: Delay,
            interval: Interval
        }
    },
    contract_entity: ContractEntity,
    contract_flow_market: ContractFlowMarket,
    contract_onboarding_type: ContractOnboardingType,
    in_stores: {
        address: {
            city: City,
            country: Country,
            postal_code: PostalCode,
            region: Region,
            street_address: StreetAddress,
            street_address2: StreetAddress2
        },
        business_concepts: BusinessConcepts,
        contact_email: ContactEmail,
        name: Name,
        selling_countries: SellingCountries,
        store_category: StoreCategory,
        store_id: StoreId,
        support_email: SupportEmail,
        support_phone: SupportPhone
    },
    merchant_id: MerchantId,
    merchant_portal_account_email: MerchantPortalAccountEmail,
    merchant_portal_account_role: MerchantPortalAccountRole,
    onboarding_metadata: {
        channel: Channel,
        distribution_partner: DistributionPartner,
        platform: Platform
    },
    payment_product: {
        countries: Countries,
        product_channel: ProductChannel,
        product_type: ProductType
    },
    platform_account: PlatformAccount,
    sensitive_goods: SensitiveGoods,
    source_identifier: SourceIdentifier,
    template_id: TemplateId,
    underwriting_inquiry_email: UnderwritingInquiryEmail
};
export function getFieldByAbsolutePath(absolutePath) {
    return getValueByPath(ALL_FIELDS, absolutePath.replace(/\[\d+\]/g, ''));
}
